import React from 'react';
import { StyleSheet, Text, View } from './base_components';
import TextButton from './buttons/text_button';

const styles = StyleSheet.create({
  actionProgress: {
    borderRadius: '1rem',
    padding: '2rem',
    alignSelf: 'stretch',
    backgroundColor: '#016de1',
    flexDirection: 'column',
  },
  actionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  action: { color: 'white', fontSize: '1.5rem', fontWeight: 'bold' },
  bar: {
    marginTop: '1rem',
    marginBottom: '1rem',
    alignSelf: 'stretch',
    height: '0.5rem',
    backgroundColor: 'rgba(255,255,255,0.5)',
    borderRadius: '0.5rem',
    overflow: 'hidden',
  },
  barDone: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    backgroundColor: 'white',
  },
  text: { color: 'white', fontSize: '1.3rem' },
});

export interface ActionProgressProps {
  style?: any;
  action: string;
  total: number;
  current: number;
  running: boolean;
  failed: boolean;
  onRetryPress: () => Promise<void> | void;
  onClosePress: () => Promise<void> | void;
}
export default function ActionProgress(props: ActionProgressProps) {
  const { action, running, failed, total, current } = props;
  const left = total - current;
  const left_percent = ((left / total) * 100).toFixed(2);
  const done_percent = ((current / total) * 100).toFixed(2);
  return (
    <View style={[styles.actionProgress, props.style]}>
      <View style={styles.actionButton}>
        <Text style={styles.action}>
          {action}
          {failed ? ' - Failed' : !running ? ' - Done!' : ''}
        </Text>
        {failed && !running ? (
          <TextButton
            type='ghost-inverted'
            text='Retry'
            onPress={props.onRetryPress}
          />
        ) : (
          <TextButton
            type='ghost-inverted'
            text='Close'
            disabled={running}
            onPress={props.onClosePress}
          />
        )}
      </View>
      <View style={styles.bar}>
        <View style={[styles.barDone, { width: done_percent + '%' }]} />
      </View>
      <Text
        style={styles.text}
      >{`Total: ${total} files, Remaining: ${left} (${left_percent}%)`}</Text>
    </View>
  );
}
